import { FormFields, FormValidationSchema } from '@/common/interfaces';

export enum ReferralFormInputs {
  Name = 'name',
  SiteId = 'siteId',
  Slug = 'slug',
}

export type ReferralFormFields = FormFields<typeof ReferralFormInputs>;

export type ReferralFormValidationSchema = FormValidationSchema<ReferralFormFields>;
